import { Action as ReduxAction } from 'redux';

import { CompositeSessionInfoSelectors, SessionSiteSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { changeCollectionVisibility } from '../../../../Collections/actions/ChangeCollectionVisibilityAction';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeCollectionVisibilityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.ChangeCollectionVisibility,
  translateName: Messages.collectionsChangeVisiblityMenu,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    if(targetItems.length !== 1) return false;

    const item = targetItems[0];
    const isAdminOrOwner = CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(item.owner)(state);
    return isAdminOrOwner && SessionSiteSelectors.isPublicCollectionsEnabled(state);
  },
  createReduxAction: (targetItems: ICollectionInfo[]): ReduxAction => {
    return changeCollectionVisibility(targetItems[0]);
  },
};

